import { Message } from "@chatscope/chat-ui-kit-react";
import { MessageDirection } from "@chatscope/use-chat";
import { classNames } from "../../helpers";
import { ChatMessage } from "./ChatMessagesList";
import { Key, useState } from "react";
import moment from "moment-timezone";

type ChatMessagesGroup = {
  message: ChatMessage;
  key: Key | null | undefined;
};

export default function ChatMessageBubble(props: ChatMessagesGroup) {
  const { message, key } = props;
  const date = moment(message.date);
  let displayDate = date.format("HH:mm");
  const [showTimestamp, setShowTimestamp] = useState(false);
  if (date.isAfter(moment().subtract(1, "hours"))) {
    displayDate = date.fromNow();
  }

  return (
    <div className="w-full md:py-2 py-1 " key={key}>
      <div
        onMouseEnter={() => setShowTimestamp(true)}
        onMouseLeave={() => setShowTimestamp(false)}
        className={classNames(
          "w-full flex  gap-1 items-end",
          message.direction === "sent" && "items-end",
          message.direction === "sent" ? "flex-row-reverse" : "flex-row"
        )}
      >
        <Message
          type={"text"}
          model={{
            position: "single",
            direction:
              message.direction === "sent"
                ? MessageDirection.Outgoing
                : MessageDirection.Incoming,
            payload: message.message,
          }}
          className={classNames(
            "w-fit max-w-[60%] p-2.5 text-sm overflow-x-hidden break-words whitespace-pre-line",
            message.direction === "sent"
              ? "bg-brandblue-600 text-white rounded-2xl rtl:rounded-tl-none ltr:rounded-tr-none"
              : "text-gray-700 bg-gray-100 rounded-2xl ltr:rounded-tl-none rtl:rounded-tr-none"
          )}
        />
        {showTimestamp && (
          <div className="text-xs text-gray-400">{displayDate}</div>
        )}
      </div>
    </div>
  );
}
